import controller from './thing-signal.controller';

const template = require('./thing-signal.html');

export default {
    bindings: {
        reset: '<',
        pushUpdate: '&',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-signal/thing-signal.component.js